import $ from 'jquery'
import counterUp from 'counterup2'

function adjustBubbleArc() {
  $('.bubbleArc-widget').each(function () {
    let width = $(this).find('.bubbleArc').width()
    let contentWidth = Math.floor(width / 2);
    $('.bubbleArc-widget').css('margin-top', contentWidth + 'px')
  });
}

function scrollAnimations() {
  var pageTop = $(document).scrollTop();
  var pageBottom = pageTop + $(window).height();
  var scrollElements = $('.page-banner .animated.page-banner-title:not(\'.processed\')'
    + ',.page-banner .animated.page-banner-messaging:not(\'.processed\')'
    + ',.bubbles-widget .bubbles-container .item.circle:not(\'.processed\')'
    + ',.capsules .item .animated.capsule:not(\'.processed\')'
    + ',.widget.image-callout .image-callout-content .background-image.animated:not(\'.processed\')');

  for (var i = 0; i < scrollElements.length; i++) {
    var scrollElement = scrollElements[i];

    if (!$(scrollElement).closest('section').hasClass('animate-section')) {
      $(scrollElement).addClass('processed');
    } else if ($(scrollElement).offset().top < pageBottom) {
      $(scrollElement).addClass('processed');
    }
  }
}

function initCounter() {
  const callback = entries => {
    entries.forEach(entry => {
      const el = entry.target
      if (entry.isIntersecting && !el.classList.contains('is-visible') && $(el).closest('section').hasClass('animate-section')) {
        counterUp(el, {
          duration: 2000,
          delay: 16,
        })
        el.classList.add('is-visible')
      }
    })
  }

  const IO = new IntersectionObserver(callback, { threshold: 1 })

  const els = document.querySelectorAll('.counter')
  els.forEach(el => IO.observe(el));
}

function removeImageAnimation() {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  $('.rte-animated').each(function () {
    var elemTop = $(this).offset().top;
    if ((elemTop <= docViewBottom) && (elemTop >= docViewTop)) {
      $(this).removeClass('rte-animated');
      $(this).addClass('rte-animated-full');
    }
  })

}

$(document).ready(function () {
  initCounter();
  adjustBubbleArc();
  scrollAnimations();
  removeImageAnimation();

  $(window).on('scroll', function () {
    scrollAnimations();
    removeImageAnimation();
  });

  $(window).on('resize', function () {
    adjustBubbleArc();
  });

  //$('.bubbles-widget .bubbles-container:not(.fixedPositions)').packery({
  //  // options
  //  itemSelector: '.item',
  //  gutter: 20,
  //  stamp: '.stamp'
  //});
});
